const monthName = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const listName = ['nts', 'adr', 'rev', 'occ', 'revpar'];
const listTitle = ['Nts', 'ADR', 'Revenue', 'Occ%', 'RevPar'];


export const columnsData = [
    {
        title: "Budget", key: "budget", children: listName.map((name, index) => ({
            key: `budget_${name}`,
            title: listTitle[index]
        }))
    },
    ...monthName.map(x => ({
        title: `Actual YTD till ${x}.`,
        key: x,
        children: listName.map((name, index) => ({
            key: `${x}_${name}`,
            title: listTitle[index]
        }))
    }))
]; 


// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/4_2Year/data.js